const OnboardingLayout = <template>{{outlet}}</template>;

export default OnboardingLayout;
